import { call } from "typed-redux-saga";
import {
  ErrorMessage,
  ErrorMessageManager,
} from "../../core/http/ErrorMessageManager";
import { Logger } from "../../core/logger";
import { takeEveryFsa } from "../operations";
import { assetActions } from "./actions";

const baseDir = window.location.href.substring(
  0,
  window.location.href.indexOf("/#/"),
);

export function* assetSaga() {
  yield takeEveryFsa(assetActions.fetchMessages.started, function* (action) {
    const messages: Record<string, ErrorMessage> = yield call(async () => {
      try {
        const result = await fetch(baseDir + "/assets/messages.json");
        const json: Record<string, ErrorMessage> = await result.json();

        return json;
      } catch (e) {
        Logger.getInstance().error(`Fetch message error`);
      }
    });

    if (messages) {
      ErrorMessageManager.Instance.setErrorMessage(messages);
    }
  });
}
